// localStorage-based mock API for D2C (Scalekit) demo mode
// Replaces real backend calls with localStorage persistence

const DB_KEY = 'netsight_d2c_db';

// Initialize mock database structure
const initDB = () => {
  try {
    const existing = localStorage.getItem(DB_KEY);
    if (existing) return JSON.parse(existing);
  } catch {}
  
  const initialDB = {
    users: [
      {
        id: 1,
        email: 'demo@scalekit.com',
        accessKey: 'demo123',
        name: 'Demo User',
        createdAt: new Date().toISOString(),
      }
    ],
    currentUserId: null,
    profile: {
  brandName: 'Celebrity Drapes',
  storeUrl: 'https://celebritydrapes.com/',
  founderName: '***',
  email: 'celebritydrapes@demo.com',
  phone: '+442071234567',
  location: 'Mumbai',
  platform: 'Shopify',
  mrr: '£50L', // dashboard madhye MRR direct nahi, revenue daily £110,805 disla
  orders: '25', // "Total Orders: 25" (Yesterday)
  aov: '£4,432', // "Average Order Value"
  cvr: '7.3%', // "Conversion Rate"
  repeatRate: '30.7%', // "Repeat Purchase Rate"
  category: 'Fashion & Apparel (Sarees/Drapes)', // "Celebrity Drapes", saree SKUs based on data
  skus: '45', // dashboard madhye total SKU count nahi milala, tasach thewla
  heroProduct: 'Madhuri Inspired Pink Saree', // "Top SKU Performance - CD-1150"
  targetCustomer: 'Urban millennials aged 25-35',
  usps: 'Sustainable materials, Fast delivery, Premium quality',
  metaRoas: '4.43x', // "Meta ROAS"
  googleRoas: '1.34x', // "Google Ads ROAS"
  adSpend: '£6,286/day', // "Total Ad Spend" (Yesterday) - monthly figure nahi disla
  emailOpen: '28%', // dashboard madhye "Email ranking - CTR 5%" hota, open rate direct nahi milala tyamule tasech thewla
  emailRevenue: '18%',
  cac: '£830', // "LTV:CAC" card - CAC
  challenge: 'Scaling profitably while maintaining quality',
  growthStage: 'stage2',
  channels: 'Meta Ads, Google Ads, Email (Klaviyo), Instagram Organic',
  context: 'Looking to improve conversion rate and reduce CAC',
},
    kitData: {
      croAudit: null,
      creativeBrief: null,
      storeAudit: null,
      paidMediaAudit: null,
      kit06078Audit: null,
      kit1518Data: null,
      kit1925Data: null,
      aiAudit: null,
      aeoGeoAudit: null,
    },
    payment: {
      mode: 'USD',
      verified: false,
      sessions: {},
    },
    admin: {
      stats: {
        totalUsers: 1,
        paidUsers: 0,
        revenue: 0,
      },
      kitOverview: {},
    },
  };
  
  localStorage.setItem(DB_KEY, JSON.stringify(initialDB));
  return initialDB;
};

// Get current DB
const getDB = () => {
  try {
    const data = localStorage.getItem(DB_KEY);
    return data ? JSON.parse(data) : initDB();
  } catch {
    return initDB();
  }
};

// Check if user has valid token
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};

// Save DB
const saveDB = (db) => {
  try {
    localStorage.setItem(DB_KEY, JSON.stringify(db));
  } catch (e) {
    console.error('Failed to save to localStorage:', e);
  }
};

// Async delay to simulate network
const delay = (ms = 100) => new Promise(resolve => setTimeout(resolve, ms));

// Mock axios-like API object
const api = {
  async get(url, config = {}) {
    await delay();
    const db = getDB();
    
    // Auth endpoints
    if (url === '/auth/me') {
      // Check for token
      const token = localStorage.getItem('token');
      if (!token) {
        return Promise.reject({ response: { status: 401, data: { message: 'Not authenticated' } } });
      }
      
      // For demo mode, return demo user
      if (token === 'demo-session-token') {
        return { 
          data: { 
            user: {
              id: 1,
              name: 'Demo User',
              firstName: 'Demo',
              lastName: 'User',
              email: 'demo@scalekit.com',
              role: 'USER'
            }
          } 
        };
      }
      
      // For regular users
      if (!db.currentUserId) {
        return Promise.reject({ response: { status: 401, data: { message: 'Not authenticated' } } });
      }
      const user = db.users.find(u => u.id === db.currentUserId);
      if (!user) {
        return Promise.reject({ response: { status: 401, data: { message: 'User not found' } } });
      }
      return { data: { user: { ...user, token: undefined, accessKey: undefined } } };
    }
    
    // Kit data endpoints
    if (url.startsWith('/kit-data/')) {
      const kitType = url.replace('/kit-data/', '');
      const kitKey = kitType.replace(/-/g, '');
      const dataKey = kitKey === 'croaudit' ? 'croAudit' :
                      kitKey === 'creativebrief' ? 'creativeBrief' :
                      kitKey === 'storeaudit' ? 'storeAudit' :
                      kitKey === 'paidmediaaudit' ? 'paidMediaAudit' :
                      kitKey === 'kit06078audit' ? 'kit06078Audit' :
                      kitKey === 'kit1518' ? 'kit1518Data' :
                      kitKey === 'kit1925' ? 'kit1925Data' :
                      kitKey === 'aiaudit' ? 'aiAudit' :
                      kitKey === 'aeogeoaudit' ? 'aeoGeoAudit' : null;
      
      if (dataKey) {
        return { data: { data: db.kitData[dataKey] || {} } };
      }
    }
    
    // Payment endpoints
    if (url === '/payments/detect-region') {
      const override = localStorage.getItem('payment_mode_override');
      if (override === 'INR' || override === 'USD') {
        return { data: { mode: override } };
      }
      return { data: { mode: db.payment.mode } };
    }
    
    if (url.startsWith('/payments/verify/')) {
      const sessionId = url.split('/').pop();
      const verified = db.payment.sessions[sessionId] || false;
      return { data: { verified } };
    }
    
    // Admin endpoints
    if (url === '/admin/stats') {
      return { data: db.admin.stats };
    }
    
    if (url === '/admin/kit-overview') {
      return { data: db.admin.kitOverview };
    }
    
    // Profile endpoint
    if (url === '/profile') {
      if (!db.currentUserId && !db.profile) {
        return { data: { profile: null } };
      }
      return { data: { profile: db.profile || {} } };
    }
    
    if (url === '/admin/users') {
      const { page = 1, limit = 15 } = config.params || {};
      const start = (page - 1) * limit;
      const users = db.users.slice(start, start + limit);
      return { 
        data: { 
          users, 
          pagination: { 
            total: db.users.length, 
            page, 
            limit, 
            totalPages: Math.ceil(db.users.length / limit) 
          } 
        } 
      };
    }
    
    if (url.match(/^\/admin\/users\/\d+\/data$/)) {
      const userId = parseInt(url.split('/')[3]);
      const user = db.users.find(u => u.id === userId);
      if (!user) {
        return Promise.reject({ response: { status: 404, data: { message: 'User not found' } } });
      }
      return { data: { data: { user, kitData: db.kitData } } };
    }
    
    return Promise.reject({ response: { status: 404, data: { message: 'Not found' } } });
  },
  
  async post(url, payload = {}) {
    await delay();
    const db = getDB();
    
    // Login
    if (url === '/auth/login') {
      const { email, accessKey } = payload;
      const user = db.users.find(u => u.email === email && u.accessKey === accessKey);
      if (!user) {
        return Promise.reject({ response: { status: 401, data: { message: 'Invalid credentials' } } });
      }
      const token = btoa(`${email}:${Date.now()}`);
      db.currentUserId = user.id;
      saveDB(db);
      localStorage.setItem('token', token);
      return { data: { token, user: { ...user, token: undefined, accessKey: undefined } } };
    }
    
    // Register
    if (url === '/auth/register') {
      const { email, accessKey, name } = payload;
      if (db.users.find(u => u.email === email)) {
        return Promise.reject({ response: { status: 400, data: { message: 'Email already exists' } } });
      }
      const newUser = {
        id: db.users.length + 1,
        email,
        accessKey,
        name: name || email.split('@')[0],
        createdAt: new Date().toISOString(),
      };
      db.users.push(newUser);
      db.admin.stats.totalUsers = db.users.length;
      saveDB(db);
      return { data: { success: true, message: 'Registration successful' } };
    }
    
    // Payment checkout
    if (url === '/payments/create-checkout-session') {
      const sessionId = `sess_${Date.now()}`;
      db.payment.sessions[sessionId] = false;
      saveDB(db);
      return { data: { sessionId, url: `/checkout/${sessionId}` } };
    }
    
    return Promise.reject({ response: { status: 404, data: { message: 'Not found' } } });
  },
  
  async put(url, payload = {}) {
    await delay();
    const db = getDB();
    
    // Profile update
    if (url === '/profile') {
      db.profile = { ...db.profile, ...payload };
      saveDB(db);
      return { data: { profile: db.profile } };
    }
    
    // Kit data saves
    if (url.startsWith('/kit-data/')) {
      const kitType = url.replace('/kit-data/', '');
      const kitKey = kitType.replace(/-/g, '');
      const dataKey = kitKey === 'croaudit' ? 'croAudit' :
                      kitKey === 'creativebrief' ? 'creativeBrief' :
                      kitKey === 'storeaudit' ? 'storeAudit' :
                      kitKey === 'paidmediaaudit' ? 'paidMediaAudit' :
                      kitKey === 'kit06078audit' ? 'kit06078Audit' :
                      kitKey === 'kit1518' ? 'kit1518Data' :
                      kitKey === 'kit1925' ? 'kit1925Data' :
                      kitKey === 'aiaudit' ? 'aiAudit' :
                      kitKey === 'aeogeoaudit' ? 'aeoGeoAudit' : null;
      
      if (dataKey) {
        const saveData = payload.data || payload.scores || payload;
        db.kitData[dataKey] = saveData;
        saveDB(db);
        return { data: { data: saveData } };
      }
    }
    
    return Promise.reject({ response: { status: 404, data: { message: 'Not found' } } });
  },
  
  async delete(url) {
    await delay();
    return Promise.reject({ response: { status: 404, data: { message: 'Not implemented' } } });
  },
};

// Attach token interceptor behavior (for compatibility)
api.interceptors = {
  request: { use: () => {} },
  response: { use: () => {} },
};

// Initialize DB on load
initDB();

export default api;
